import MuiAvatar from '@mui/material/Avatar';

const Avatar = ({ restaurant, firstLetter }: { restaurant: any; firstLetter: string }) => {
    if (restaurant) return <MuiAvatar alt="Restaurant logo" src={restaurant?.logo_big_url || ''} />;
    return <MuiAvatar>{firstLetter}</MuiAvatar>;
};

export default Avatar;
